import { Box, ColorPreset, useTheme } from "@gocardless/flux-react";

import { HeaderLayout } from "./Headers/HeaderLayout";
import { LayoutProps } from "./types";
import { layoutGutterVStyle } from "./styles";

export interface SingleFixedLayoutProps extends LayoutProps {
  /**
   * Allows xs breakpoint to have a full screen view
   */
  xsFullScreenView?: boolean;
}

const MAX_WIDTH_LG = "824px";
const MAX_WIDTH_MD = "760px";
const MAX_WIDTH_SM = "712px";

export const SingleFixedLayout: React.FC<SingleFixedLayoutProps> = ({
  children,
  header,
  xsFullScreenView,
}) => {
  const { theme } = useTheme();

  const defaultBg = ColorPreset.BackgroundLight_02;

  const xsBg = xsFullScreenView ? ColorPreset.BackgroundLight_01 : defaultBg;

  return (
    <Box
      layout="flex"
      flexDirection="column"
      bg={[xsBg, defaultBg]}
      minHeight="100dvh"
    >
      {header && (
        <HeaderLayout progressBar={header.progressBar}>
          {header.content}
        </HeaderLayout>
      )}
      <Box
        gutterH={[1.5, null, 2, 4, null]}
        maxWidth={[MAX_WIDTH_SM, null, MAX_WIDTH_MD, MAX_WIDTH_LG]}
        width="100%"
        css={[layoutGutterVStyle(theme), { margin: "0 auto" }]}
        flexGrow={1}
      >
        {children}
      </Box>
    </Box>
  );
};
